import loadable from '@loadable/component'

import { THEME_NAME } from 'utils/helperConfig'

const loadableRetry = (componentImport, retries = 3, delay = 500) =>
    new Promise((resolve, reject) => {
        const attempt = () => {
            componentImport()
                .then(resolve)
                .catch(error => {
                    if (retries <= 0) {
                        window.location.replace('/refresh-page')

                        return
                    }
                    setTimeout(() => {
                        retries--
                        attempt()
                    }, delay)
                })
        }

        attempt()
    })

export const COMPONENT_EXTENDER = (name: string) => {
    const start = name.lastIndexOf('/')
    const end = name.length
    const path = name.substring(0, start)
    const component = name.substring(start + 1, end)

    // check if override component exist
    try {
        require(`./${path}/override/${THEME_NAME}/${component}`)

        return loadable(() => loadableRetry(() => import(`./${path}/override/${THEME_NAME}/${component}`)))
    } catch {
        // check again if override component exist, but this time assume that it's with index file
        try {
            require(`./${path}/${component}/override/${THEME_NAME}`)

            return loadable(() => loadableRetry(() => import(`./${path}/${component}/override/${THEME_NAME}`)))
        } catch {
            return loadable(() => loadableRetry(() => import(`./${path}/${component}`)))
        }
    }
}
